import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { StatesArray } from '../../global/constants';

import { BlueSwipeIndAccountFormSchema, BlueSwipeBusAccountFormSchema } from '../validation';
import { buildDropdown } from '../../dashboard/account/edit-bankaccount-billing-component';
import { onProfileCompletionSkip } from '../../registration/forms/generic/userInfo2Form';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  global: state.Global,
  dashboard: state.Dashboard
});

const defaultInitialValues = {
  bill_businessName: '',
  bill_tin: '',
  bill_firstName: '',
  bill_lastName: '',
  bill_accountNumber: '',
  bill_routingNumber: '',
  bill_address1: '',
  bill_address2: '',
  bill_zip: '',
  bill_city: '',
  bill_state: '',
  bnk_accountNumber: '',
  bnk_routingNumber: ''
}

const cssFormControlErrorInput = "form-control error-input";
const cssFormControl = "form-control";

class BankAccountForm_BlueSwipe extends Component {
  constructor(props) {
    super(props);

    this.state = { type: 'individual' }
    this.onSubmit = this.onSubmit.bind(this);
    this.getClassNames = this.getClassNames.bind(this);
  }

  onSubmit(values, form) {
    let { handleSubmit } = this.props;
    values.type = this.state.type;
    handleSubmit(values, form);
  }

  getClassNames = (errors, touched) => {
    let billFirstNameCss = cssFormControl;
    if (errors.bill_firstName && touched.bill_firstName)
      billFirstNameCss = cssFormControlErrorInput;

    let billLastNameCss = cssFormControl;
    if ((errors.bill_lastName && touched.bill_lastName))
      billLastNameCss = cssFormControlErrorInput;

    let billBusinessNameCss = cssFormControl;
    if (errors.bill_businessName && touched.bill_businessName)
      billBusinessNameCss = cssFormControlErrorInput;

    let billTINCss = cssFormControl;
    if (errors.bill_tin && touched.bill_tin)
      billTINCss = cssFormControlErrorInput;

    let addressCss = cssFormControl;
    if (errors.bill_address1 && touched.bill_address1)
      addressCss = cssFormControlErrorInput;

    let addressCss2 = cssFormControl;
    if (errors.bill_address2 && touched.bill_address2)
      addressCss2 = cssFormControlErrorInput;

    let zipCss = cssFormControl;
    if (errors.bill_zip && touched.bill_zip)
      zipCss = cssFormControlErrorInput;

    return {
      billFirstNameCss,
      billLastNameCss,
      billBusinessNameCss,
      billTINCss,
      addressCss,
      addressCss2,
      zipCss
    }
  }

  renderCityState(isMobile, errors, touched) {
    const billCityCSS = (errors.bill_city && touched.bill_city) ? cssFormControlErrorInput : cssFormControl;
    return isMobile
      //Mobile View
      ? (<div><div className="fieldgroup fieldgroup-required">
        <Field
          name="bill_city"
          type="text"
          placeholder="City"
          className={billCityCSS}
        />
        <ErrorMessage
          name="bill_city" component="div" className="error-message" />
      </div>
        <div className="fieldgroup fieldgroup-required" >
          {
            buildDropdown("bill_state", StatesArray, "State", "State", (errors.bill_state && touched.bill_state))
          }
          <ErrorMessage
            name="bill_state" component="div" className="error-message" />
        </div></div>
      )
      //Desktop View
      : (
        <div className="fieldgroup row">
          <div className="col-8 pl-0 fieldgroup-required">
            <Field name="bill_city" type="text"
              placeholder="City" className={billCityCSS}
            />
          </div>
          <div className="col-4 pr-0 fieldgroup-required fieldgroup-select">
            {buildDropdown("bill_state", StatesArray, "State", "State", (errors.bill_state && touched.bill_state))}
          </div>
          {((errors.bill_city && touched.bill_city)
            || (errors.bill_state && touched.bill_state))
            && (<div className="error-message">This field is required</div>)}
        </div>)
  }

  render() {
    let { handleBack, errorMessage, initialValues, isMobile, isModal, dispatch, isMandatory } = this.props;
    let { type } = this.state;
    return (
      <div>
        <div>
          <h2>Account Type</h2>
          <div className="d-flex">
            <div className="ml-3 fieldgroup">
              <label>
                <input type="radio"
                  name="type"
                  onChange={() => { this.setState({ type: 'individual' }) }}
                  value="individual"
                  checked={type === 'individual'}
                />
                Individual
              </label>
            </div>
            <div className="ml-3 fieldgroup">
              <label>
                <input type="radio"
                  name="type"
                  onChange={() => { this.setState({ type: 'business' }) }}
                  value="business"
                />
                Business
              </label>
            </div>
          </div>
        </div>
        <Formik
          validationSchema={type === 'individual' ? BlueSwipeIndAccountFormSchema : BlueSwipeBusAccountFormSchema}
          initialValues={initialValues ? initialValues : defaultInitialValues}
          onSubmit={this.onSubmit}>
          {({ values, errors, touched, isSubmitting }) => {

            const classNames = this.getClassNames(errors, touched);

            return (
              <Form>
                <div>
                  <h2>Billing Address</h2>
                  <div><i className="fas fa-asterisk required-asterisk"></i> Indicates required field</div>
                  <div>
                    <div className="fieldgroup fieldgroup-required">
                      <Field
                        name="bill_firstName"
                        type="text"
                        placeholder="First Name"
                        className={classNames.billFirstNameCss}
                      />
                      <ErrorMessage name="bill_firstName" component="div" className="error-message" />
                    </div>
                    <div className="fieldgroup fieldgroup-required">
                      <Field
                        name="bill_lastName"
                        type="text"
                        placeholder="Last Name"
                        className={classNames.billLastNameCss}
                      />
                      <ErrorMessage name="bill_lastName" component="div" className="error-message" />
                    </div>
                    {type === 'business' && (
                      <div className="fieldgroup fieldgroup-required">
                        <Field
                          name="bill_businessName"
                          type="text"
                          placeholder="Company Name"
                          className={classNames.billBusinessNameCss}
                        />
                        <ErrorMessage name="bill_businessName" component="div" className="error-message" />
                      </div>
                    )}
                    {type === 'business' && (
                      <div className="fieldgroup fieldgroup-required">
                        <Field
                          name="bill_tin"
                          type="text"
                          placeholder="Company TIN"
                          className={classNames.billTINCss}
                        />
                        <ErrorMessage name="bill_tin" component="div" className="error-message" />
                      </div>
                    )}
                    <div className="fieldgroup fieldgroup-required">
                      <Field
                        name="bill_address1"
                        type="text"
                        placeholder="Address Line 1"
                        className={classNames.addressCss}
                      />
                      <ErrorMessage name="bill_address1" component="div" className="error-message" />
                    </div>
                    <div className="fieldgroup">
                      <Field
                        name="bill_address2"
                        type="text"
                        placeholder="Address Line 2 (Optional)"
                        className={classNames.addressCss2}
                      />
                    </div>
                    {this.renderCityState(isMobile, errors, touched)}
                    <div className="fieldgroup fieldgroup-required">
                      <Field
                        name="bill_zip"
                        type="text"
                        placeholder="Zip Code"
                        className={classNames.zipCss}
                      />
                      <ErrorMessage name="bill_zip" component="div" className="error-message" />
                    </div>
                  </div>
                  <h2>Bank Account</h2>
                  <p>Your bank account info is required to accept payment and is securely encrypted and stored by our Payment Processor.</p>
                  <div>
                    <div className="fieldgroup row fieldgroup-required">
                      <Field
                        name="bnk_accountNumber"
                        type="text"
                        placeholder="Bank Account Number"
                        className={(errors.bnk_accountNumber && touched.bnk_accountNumber) ? cssFormControlErrorInput : cssFormControl}
                      />
                      <ErrorMessage name="bnk_accountNumber" component="div" className="error-message" />
                    </div>
                    <div className="fieldgroup row fieldgroup-required">
                      <Field
                        name="bnk_routingNumber"
                        type="text"
                        placeholder="Bank Routing Number"
                        className={(errors.bnk_routingNumber && touched.bnk_routingNumber) ? cssFormControlErrorInput : cssFormControl}
                      />
                      <ErrorMessage name="bnk_routingNumber" component="div" className="error-message" />
                    </div>
                  </div>
                  <div>
                    {errorMessage && (<div className="error-message mb-3">{errorMessage.message}</div>)}
                    <div className={`button-row row ${isModal ? 'modal-footer pb-0' : ''}`}>
                      <div className="col">
                        <label onClick={handleBack}>Back</label>
                      </div>
                      <div className="col text-right submit-btn">
                        {
                          !isMandatory && <button className="btn btn-primary skip-button" type='button'
                            onClick={() => { onProfileCompletionSkip(dispatch) }}>Skip for Now</button>
                        }
                        <button className="btn btn-primary" disabled={isSubmitting} type="submit">{isSubmitting ? 'Verifying...' : 'Submit'}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>)
          }}
        </Formik>
      </div>
    )
  }
}

export default connect(mapStateToProps)(BankAccountForm_BlueSwipe);
